import Vue from 'vue'
import Vuetify, {
    VForm,
    VApp,
    VCarousel,
    VCarouselItem,
    VSheet,
    VRow,
    VColorPicker,
    VDatePicker,
    VTimePicker,
    VCol,
    VMenu,
    VSpacer,
    VToolbar,
    VBtn,
    VCalendar,
    VIcon,
    VCheckbox,
    VToolbarTitle,
    VList,
    VListItem,
    VListItemTitle,
    VSelect,
    VAutocomplete,
    VAvatar,
    VRadio,
    VListItemContent,
    VChip,
    VDialog,
    VCard,
    VCardActions,
    VCardText,
    VSlideGroup,
    VSlideItem,
    VScaleTransition,
    VCombobox,
    VListItemAction,
    VContainer,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanelContent,
    VExpansionPanels,
    VSlider,
    VTooltip,
    VSwitch,
    VNavigationDrawer,
    VTab,
    VTabs,
    VTabItem,
    VTabsItems,
    VTabsSlider,
    VBtnToggle,
    VDivider,
    VStepperStep,
    VStepper,
    VStepperHeader,
    VTimeline,
    VTimelineItem,
    VExpandTransition,
    VListItemAvatar,
    VCardTitle,
    VListItemSubtitle,
    VSkeletonLoader,
    VProgressCircular,
    VAlert,
    VOverlay,
    VProgressLinear,
    VHover,
    VTextarea,
    VContent,
    VRangeSlider,
    VSimpleTable,
    VInput,
    VStepperContent,
    VFileInput,
    VLabel,
} from 'vuetify/lib'
import { VTextField } from 'vuetify/lib/components'
import VRadioGroup from 'vuetify/lib/components/VRadioGroup'

Vue.use(Vuetify, {
    components: {
        VForm,
        VInput,
        VApp,
        VCarousel,
        VCarouselItem,
        VSheet,
        VRow,
        VColorPicker,
        VTextField,
        VDatePicker,
        VTimePicker,
        VCol,
        VMenu,
        VSpacer,
        VToolbar,
        VBtn,
        VCalendar,
        VIcon,
        VCheckbox,
        VToolbarTitle,
        VList,
        VListItem,
        VListItemTitle,
        VSelect,
        VAutocomplete,
        VAvatar,
        VRadio,
        VListItemContent,
        VChip,
        VDialog,
        VCard,
        VCardActions,
        VCardText,
        VSlideGroup,
        VSlideItem,
        VScaleTransition,
        VCombobox,
        VListItemAction,
        VContainer,
        VExpansionPanel,
        VExpansionPanelHeader,
        VExpansionPanelContent,
        VExpansionPanels,
        VSlider,
        VTooltip,
        VSwitch,
        VNavigationDrawer,
        VTab,
        VTabs,
        VTabItem,
        VTabsItems,
        VTabsSlider,
        VBtnToggle,
        VDivider,
        VStepperStep,
        VStepper,
        VStepperHeader,
        VTimeline,
        VTimelineItem,
        VExpandTransition,
        VListItemAvatar,
        VCardTitle,
        VListItemSubtitle,
        VSkeletonLoader,
        VProgressCircular,
        VAlert,
        VOverlay,
        VProgressLinear,
        VHover,
        VTextarea,
        VContent,
        VRangeSlider,
        VSimpleTable,
        VStepperContent,
        VFileInput,
        VLabel,
        VRadioGroup,
    },
})

const opts = {
    icons: {
        iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
    theme: {
        dark: localStorage.getItem('theme') === 'dark',
    },
}

export default new Vuetify(opts)
